// Função auxiliar para formatar os dados do assistente
export function formatAssistantData(assistantData, user) {
    return {
        _id: assistantData.data?._id || null,
        type: assistantData.data?.type || null,
        // Flag de capacidades: busca na web habilitada para este self-assistant
        web_search_enabled: assistantData.data?.web_search_enabled ?? false,
        // Capacidades n8n
        n8n_tools_enabled: assistantData.data?.n8n_tools_enabled ?? false,
        n8n_tools: assistantData.data?.n8n_tools ?? [],
        // Provedor LLM local (cluster Ollama)
        llm_provider: assistantData.data?.llm_provider ?? 'azure',
        local_cluster_config: {
            api_key: assistantData.data?.local_cluster_config?.api_key ?? '',
            model: assistantData.data?.local_cluster_config?.model ?? '',
            vision_capable: assistantData.data?.local_cluster_config?.vision_capable ?? false,
        },
        assistant: {
            icon: assistantData.data?.assistant.icon || null,
            name: assistantData.data?.assistant.name || '',
            description: assistantData.data?.assistant.description || [''],
            instructions: assistantData.data?.assistant.instructions || '',
        },
        info_model: {
            model: assistantData.data?.info_model.model || 'gemini-3.5-flash-lite',
            temperature: assistantData.data?.info_model.temperature || 0.80,
            n_tokens: assistantData.data?.info_model.n_tokens || 2400,
            top_p: assistantData.data?.info_model.top_p || 1.00,
            frequency_penalty: assistantData.data?.info_model.frequency_penalty || 0.00,
            presence_penalty: assistantData.data?.info_model.presence_penalty || 0.00,
        },
        database: assistantData.data?.database || [],
        users: assistantData.data?.users || [], // é uma lista de dicionários (dicionários com chave email)
        adms: assistantData.data?.adms || [], // é uma lista de dicionários (dicionários com chave email)
        created_by: assistantData.data?.created_by || user,
        created_at: assistantData.data?.created_at || new Date().toISOString().split('T')[0],
        updated_at: new Date().toISOString().split('T')[0],
        status: assistantData.data?.status || false
    };
}